import { isLocalEnv } from './env'

// keep in sync with frame-ancestors in nginx/nginx.conf
const DEEPSIGN_HOSTNAMES = new Set([
  'dev.deepsign.swiss',
  'dev2.deepsign.swiss',
  'dev3.deepsign.swiss',
  'int.deepsign.swiss',
  'demo.deepsign.swiss',
  'app.deepsign.swiss',
])

function isDeepSignUrl(url: URL) {
  // a local DeepSign dev server runs on plain http://localhost
  if (isLocalEnv() && url.hostname === 'localhost') return true

  return url.protocol === 'https:' && DEEPSIGN_HOSTNAMES.has(url.hostname)
}

/** Parse `raw` as a URL on a DeepSign host; anything else yields undefined. */
export function parseDeepSignUrl(raw: unknown): URL | undefined {
  if (typeof raw !== 'string' || !raw) return undefined

  try {
    const url = new URL(raw)
    return isDeepSignUrl(url) ? url : undefined
  } catch {
    return undefined
  }
}
